exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".individual-text-output{position:relative;display:inline-block;text-align:left}.individual-text-output__layer{position:absolute;overflow:hidden;pointer-events:none;z-index:100}.individual-text-output__text{position:absolute;box-sizing:border-box;overflow:hidden}.individual-text-output__text--placeholder{opacity:.4}.individual-text-output__text--editable{pointer-events:auto;cursor:move;outline:1px dashed hsla(0,0%,100%,.8);box-shadow:0 0 0 1px rgba(0,0,0,.35);user-select:none}.individual-text-output__line{position:absolute;white-space:nowrap}.individual-text-output__guide{position:absolute;pointer-events:none;background:#f6264c}.individual-text-output__guide--x{top:0;bottom:0;width:1px}.individual-text-output__guide--y{left:0;right:0;height:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/individual-text-output-preview/individual-text-output-preview.scss
// module id = 826
// module chunks = 0